import Vue from "vue";
import { Store } from "vuex";
import { Action, Module, Mutation, VuexModule, getModule } from "vuex-module-decorators";

import { processCoreModelResponse } from "@/store/-utils";
import RecommendationsApi from "@/store/recommendations/-api";

const DEFAULT_RECOMMENDATIONS_LIMIT = 30;

@Module({
  name: "recommendations",
  stateFactory: true,
  namespaced: true,
})
export default class RecommendationsStore extends VuexModule {
  recommendedProfilesSuggestions: SearchSuggestion[] = [];

  @Action({ rawError: true })
  async fetchRecommendedProfiles(limit = DEFAULT_RECOMMENDATIONS_LIMIT) {
    const api = new RecommendationsApi(this.store.$axios);
    const response = await api.getRecommenedProfile(limit);
    await processCoreModelResponse(this.store, response.data);

    const profileSuggestions = response.data.profiles || [];

    // set profile suggestions to use in autocomplete
    const updatedProfilesSuggestions = profileSuggestions.map((item) => {
      return {
        objectID: item.id,
        query: item.displayName,
        avatarUrl: item.avatarUrl ? `${item.avatarUrl}?v=0&format=auto&w=100&h=100&fit=crop&q=80` : "",
      };
    });

    this.setRecommendedProfilesSuggestions(updatedProfilesSuggestions);
  }

  @Mutation
  setRecommendedProfilesSuggestions(profiles: SearchSuggestion[]) {
    Vue.set(this, "recommendedProfilesSuggestions", profiles);
  }
}

export const getRecommendationsStore = (store: Store<unknown>) => {
  return getModule(RecommendationsStore, store);
};
